"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransactionFlowFilterEnum = void 0;
var TransactionFlowFilterEnum;
(function (TransactionFlowFilterEnum) {
    TransactionFlowFilterEnum["INFLOW"] = "INFLOW";
    TransactionFlowFilterEnum["OUTFLOW"] = "OUTFLOW";
})(TransactionFlowFilterEnum || (exports.TransactionFlowFilterEnum = TransactionFlowFilterEnum = {}));
